import { render, staticRenderFns } from "./__Product.vue?vue&type=template&id=99325646&"
import script from "./__Product.vue?vue&type=script&lang=js&"
export * from "./__Product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports